export default __webpack_public_path__ + "static/media/flyerImg.7b48b00c.jpg";